(<template>
  <header class="s-header">
    <router-link :to="$makeRoute({name: 'ServerHome'})"
                 class="s-header__logo" />
    <router-link :to="$makeRoute({name: 'ServerHome'})"
                 class="s-header__nav-link s-header__logo-link">{{ $gettext('Home') }}</router-link>
    <header-nav-dropdown v-if="!isTranslationOnly"
                         :dropdown-subtitle="interpretationDropdownSubtitle"
                         :links="interpretationDropdownLinks"
                         class="s-header__nav-dropdown" />
    <router-link v-if="userIsSeller"
                 :to="projectsLink"
                 class="s-header__nav-link">{{ $pgettext('translation', 'Translation') }}</router-link>
    <p v-if="$isGodmode()"
       class="sk-btn sk-btn--white s-header__godmode-btn">{{ $gettext('Admin mode') }}</p>
    <div class="s-header__account-cont">
      <div v-if="!isTranslationOnly"
           class="s-header__invitations-cont">
        <router-link :to="jobInvitationsPageLink"
                     :class="{'new-job-invitation': newInvitation}"
                     class="s-header__link bell-icon">{{ $gettext('Invitations') }}</router-link>
      </div>
      <language-selector v-if="!isMobileView" />
      <a :href="'https://support.salita.no/collection/362-tolk'"
         target="_blank"
         class="s-header__link help-link">{{ $gettext('Help') }}</a>
      <button ref="accountBtn"
              :class="{'header__account-btn--active': subnavShown}"
              class="header__account-btn"
              @click.stop="toggleSubnav">
        <tt-avatar :own="true"
                   class="s-header__account-avatar" />
      </button>
      <header-account-subnav v-if="subnavShown" />
    </div>
  </header>
</template>)

<script>
  import {mapGetters, mapState} from 'vuex';
  import LanguageSelector from '@/components/dashboard_components/LanguageSelector';
  import HeaderNavDropdown from '@/components/shared_components/HeaderNavDropdown';
  import HeaderAccountSubnav from '@/components/navigations/header_account_subnav/HeaderAccountSubnav';

  export default {
    components: {
      'header-nav-dropdown': HeaderNavDropdown,
      'language-selector': LanguageSelector,
      'header-account-subnav': HeaderAccountSubnav
    },
    data() {
      return {
        subnavShown: false,
        clientWidth: 768
      };
    },
    computed: {
      ...mapState('s_DashboardStore', {
        newInvitation: (state) => state.newInvitation
      }),
      ...mapGetters('UserInfoStore', [
        'userUid',
        'userIsSeller',
        'isTranslationOnly',
      ]),
      interpretationDropdownLinks() {
        return [
          {
            text: this.$gettext('Interpretation assignments'),
            type: 'router-link',
            iconClass: 'interpretation-assignments-icon',
            action: this.assignmentsLink,
            condition: true
          },
          {
            text: this.$gettext('Calendar'),
            type: 'router-link',
            iconClass: 'calendar-icon',
            action: this.calendarLink,
            condition: true
          },
        ];
      },
      calendarLink() {
        return this.$makeRoute({
          name: 'ServerCalendar',
          query: {
            view: 'week',
            date: this.$moment().format('YYYY-MM-DD')
          }
        });
      },
      projectsLink() {
        return this.$makeRoute({
          name: 'ServerAllProjects',
          query: {
            availableStatus: 'new',
            acceptedStatus: 'active'
          }
        });
      },
      assignmentsLink() {
        return this.$makeRoute({
          name: 'ServerAllAssignments',
          query: {
            view: 'current',
            sortConfirmedBy: 1,
            sortAvailableBy: 1,
            pageConfirmedBy: 1,
            pageAvailableBy: 1
          }
        });
      },
      jobInvitationsPageLink() {
        return this.$makeRoute({name: 'ServerAllInvitations'});
      },
      isMobileView() { return this.clientWidth < 768; },
      interpretationDropdownSubtitle() { return this.$gettext('Interpretation'); }
    },
    methods: {
      toggleSubnav(e) {
        this.toggleAbsoluteBlocks();
        this.subnavShown = !this.subnavShown;
        if (e.target.className.indexOf('s-header__account-') != -1) {
          this.$refs.accountBtn.blur();
        }
      },
      toggleAbsoluteBlocks(e) {
        if (e && (e.target.className.indexOf('s-header__account-') != -1 && e.target.className.indexOf('s-header__notifications-') != -1)) {
          return;
        }
        if (e && e.target.className.indexOf('language-dropdown') != -1) {
          return;
        }
        this.subnavShown = false;
      },
      setClientWidth() {
        this.clientWidth = document.documentElement.clientWidth;
      }
    },
    mounted() {
      this.setClientWidth();
      document.addEventListener('click', this.toggleAbsoluteBlocks);
      window.addEventListener('resize', this.setClientWidth);
    }
  };
</script>

<style scoped>
  .s-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    width: 100%;
    height: 60px;
    background-color: #fff;
    box-shadow: var(--block-shadow);
  }

  .input-focused .s-header {
    position: absolute;
  }

  .s-header__logo {
    display: block;
    width: 130px;
    background: var(--image-logo) no-repeat 50% 50% / 100px auto;
  }

  .s-header__godmode-btn {
    display: inline-block;
    align-self: center;
    width: auto;
    height: 35px;
    margin-left: 10px;
    padding: 0 10px;
  }

  .s-header__nav-link {
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: #000;
  }

  .s-header__nav-link:hover,
  .s-header__link:hover {
    background-color: #f4f5f7;
    transition: ease-in-out 0.125s;
  }

  .s-header__nav-link:focus,
  .s-header__link:focus {
    outline: var(--focus-outline);
  }

  .s-header__link {
    display: inline-block;
    color: #000;
    line-height: 60px;
  }

  .s-header__logo-link {
    display: inline-block;
    padding: 0 10px;
    padding-left: 15px;
    line-height: 60px;
  }

  .s-header__account-cont {
    display: flex;
    margin-left: auto;
  }

  .s-header__account-avatar {
    width: 30px;
    height: 30px;
  }

  .s-header__invitations-cont {
    position: relative;
    display: flex;
  }

  .bell-icon {
    padding-left: 35px;
    background-image: url(~@assets/imgs/nav_icons/bell_icon.svg);
    background-position: 5% center;
    background-size: 25px auto;
    background-repeat: no-repeat;
  }

  .bell-icon.new-job-invitation::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 25px;
    box-sizing: border-box;
    padding: 3px;
    border-radius: 100%;
    background: var(--color-primary);
  }

  .s-header__logo-link:focus {
    outline: 2px solid #3af;
  }

  .s-header__logo-link:hover {
    background-color: #f4f6f8;
  }

  .s-header__logo-link:active {
    background-color: #e8e9ed;
    outline: none;
  }

  .s-header__nav-avatar {
    position: absolute;
    top: 7px;
    left: 17px;
    width: 30px;
    height: 30px;
  }

  .s-header__nav-avatar--subnav {
    position: relative;
    top: 0;
    left: 0;
    margin-right: 10px;
  }

  @media (max-width: 767px) {
    .s-header {
      height: 48px;
    }

    .s-header__nav-link,
    .s-header__nav-dropdown {
      display: none;
    }

    .s-header__godmode-btn {
      display: none;
    }

    .s-header__logo {
      flex-shrink: 0;
      background-size: 85px auto;
    }

    .help-link,
    .s-header__invitations-cont {
      display: none;
    }
  }
</style>
